import { districtBelongsToCity } from './locationOptions';
import React, {useState} from 'react'
import { Box, Typography, TextField, Select, MenuItem, Switch, Button, InputLabel, BottomNavigation, BottomNavigationAction, FormControl, Grid, OutlinedInput, Snackbar, Alert, FormHelperText, InputAdornment, IconButton } from '@mui/material'
import UploadFileIcon from "@mui/icons-material/UploadFile";

import { useForm, Controller } from 'react-hook-form'
import { useRedirect } from 'react-admin'
import generateToken from '../../utils/generateToken'
import globalStyles from '../../utils/globalStyles'
import axios from 'axios'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import legolasApi from '../../api/legolas'
import elrondApi from '../../api/elrond'

import uilityApi from '../../api/utility';

function CreateUser(props) {
  const [actionTab, setActiontab] = React.useState(1)
  const { handleSubmit, control, reset, getValues, watch, setValue, setError, clearErrors } = useForm({
    defaultValues: {
      otp_verified: '',
      group: 1,
      // gender: 'male',
      // email_lang: 'english'
    }
  })
  //const [dobValue, setDobValue] = React.useState(dayjs(new Date()))
  const [dobValue, setDobValue] = React.useState(null);
  const [channel, setChannel] = React.useState('1'); // Default to Shababuna Website
  const [openAlert, setOpenAlert] = React.useState(false)
  const [alertText, setAlertText] = React.useState('')
  const [countryList, setCountryList] = React.useState([]);
  const [districtList, setDistrictList] = React.useState([])
  const [cityList, setCityList] = React.useState([])
  const [countryPhoneExt, setCountryPhoneExt] = React.useState('+966')
  const [phonePH, setPhonePH] = React.useState('5X XXX XXXX')
  const [countryExtCodes, setCountryExtCodes] = React.useState([
    { code: 'SA', text: '+966', length: 9, start: ['5'], emoji: "🇸🇦", flag: '/static/content/flag-saudi.png', regEx: '^(5)[0-9]{8}$', repExp: '^(00966|966|\\+966)', pHolder: '5X XXX XXXX' },
    { code: 'AE', text: '+971', length: 9, start: ['5'], emoji: "🇦🇪", flag: '/static/content/flag-uae.png', regEx: '^(5)[0-9]{8}$', repExp: '^(00971|971|\\+971)', pHolder: '5X XXX XXXX' },
    { code: 'BH', text: '+973', length: 8, start: ['3'], emoji: "🇧🇭", flag: '/static/content/flag-baharain.png', regEx: '^(3)[0-9]{7}$', repExp: '^(00973|973|\\+973)', pHolder: '3X XXX XXX' },
    { code: 'OM', text: '+968', length: 8, start: ['7', '9'], emoji: "🇴🇲", flag: '/static/content/flag-oman.png', regEx: '^(7|9)[0-9]{7}$', repExp: '^(00968|968|\\+968)', pHolder: '7X XXX XXX' },
    { code: 'KW', text: '+965', length: 8, start: ['9'], emoji: "🇰🇼", flag: '/static/content/flag-kuwait.png', regEx: '^(9)[0-9]{7}$', repExp: '^(00965|965|\\+965)', pHolder: '9X XXX XXX' },
    //{ code: 'IN', text: '+91', length: 10, start: ['6', '7', '8', '9'], emoji: "", flag: '/static/content/flag-india.png', regEx: '(6|7|8|9)[0-9]{9}$', repExp: '^(0091|91|\\+91)', pHolder: '9XXXX XXXXX'}
    { code: 'QA', text: '+974', length: 8, start: ['3', '5', '9'], emoji: "", flag: '/static/content/flag-qatar.png', regEx: '^(3|5|9)[0-9]{7}$', repExp: '^(00974|974|\\+974)', pHolder: '3X XXX XXX' },
  ])
  const [defaultCountryList, setDefaultCountryList] = React.useState([]);

  const [focus, setFocus] = React.useState(false);
  const [addressData, setAddressData] = React.useState({
    customer_firstname: "",
    customer_lastname: "",
    street: "",
    country: "Saudi Arabia",
    country_id: 1,
    country_code: "SA",
    city_id: "",
    city: "",
    district_id: "",
    district: "",
    postcode: "",
    phone_ext: "",
    phone: "",
    building_no: "",
    id_proof_document: null,
    address_proof_document: null,
    customer_unique_id: "",
  });
  const websiteMap = {
    "1": process.env.REACT_APP_SHABABUNA_CHANNEL_ID || "657979c059be05f5f8dd41f6",
    "2": process.env.REACT_APP_SENSI_CHANNEL_ID || "65aa1936f6055e8f029f6eb5",
    "3": process.env.REACT_APP_B2B_CHANNEL_ID || "657979c059be05f5f8dd41f7",
  };

const [idProofFile, setIdProofFile] = React.useState(null);
const [addressProofFile, setAddressProofFile] = React.useState(null);
const [isSaving, setIsSaving] = useState(false);
const [citySearch, setCitySearch] = React.useState("");
const [districtSearch, setDistrictSearch] = React.useState("");

  const idTypes = watch("id_types") || [];

  function isValidSaudiVAT(vat) {
    if (!vat) return false;

    vat = vat.replace(/\D/g, '');

    return /^3\d{12}03$/.test(vat);
  }
  React.useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === 'id_type') {
        setValue('id_value', '');
        clearErrors('id_value');
      }
    });

    return () => subscription.unsubscribe();
  }, [watch, setValue, clearErrors]);
  const redirect = useRedirect()

  const redirectToList = () => {
    redirect('/users')
  }

  const resetForm = () => {
    reset({
      otp_verified: '',
      group: 1,
      gender: 'male',
      email_lang: 'english',
      firstname: '',
      middlename: '',
      lastname: '',
      mobile_number: '',
      email: '',
      dob: dayjs(new Date()),
      building_no: '',
      customer_unique_id: '',
    });
    setAddressData({
      customer_firstname: "",
      customer_lastname: "",
      street: "",
      country: "Saudi Arabia",
      country_id: 1,
      country_code: "SA",
      city_id: "",
      city: "",
      district_id: "",
      district: "",
      postcode: "",
      phone_ext: "",
      phone: "",
      building_no: "",
      id_proof_document: null,
      address_proof_document: null,
      customer_unique_id: "",
    });

  };

 
  const controllerFields = {
    margin: '10px 30%',
    width: '500px',
    // borderBottom: '2px solid #2b3f7a',
    borderRadius: 0,
    "& .MuiFilledInput-input": {
      backgroundColor: '#fff !important'
    }
  }

  const controllerDropdowns = {
    margin: '10px 30%',
    width: '500px',
    border: '2px solid #2b3f7a',
    borderRadius: 0
  }
  const standardMenuProps = {
    PaperProps: {
      sx: { mt: 1, borderRadius: 1, zIndex: 1300 },
    },
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    transformOrigin: { vertical: "top", horizontal: "left" },
  };
  // Load default country, city, district on mount
  React.useEffect(() => {
    getAddressFormData("SA"); // default country code
  }, []);

  const getAddressFormData = (defaultCountry) => {
    axios.get(`${elrondApi.url}/hnak/locationdata/${elrondApi.source}`).then(res => {

      const defaultCountryFormData = res.data.data;
      setDefaultCountryList(defaultCountryFormData);
      setAddressFormData(defaultCountryFormData, defaultCountry);

    }).catch((error) => {
      console.log("Error in load address data", error);
    });
  }
  const setAddressFormData = (countryList, defaultCountry) => {
    const foundCountry = countryList.find(country => country.code == defaultCountry)
    setCountryList(countryList);
    let defaultCityList = foundCountry?.cities || []
    let defaultDistrictList = foundCountry?.districts || []
    if (defaultCountry === "SA") {
      defaultCityList = defaultCityList.filter(c => c.value !== "Others");
      defaultDistrictList = defaultDistrictList.filter(d => d.value !== "Others");
    }
    defaultCityList = [...defaultCityList].sort((a, b) =>
      a.value.localeCompare(b.value)
    );

    defaultDistrictList = [...defaultDistrictList].sort((a, b) =>
      a.value.localeCompare(b.value)
    );
    setCityList(defaultCityList);
    setDistrictList(defaultDistrictList);
  }

  const handleFocus = () => {
    setFocus(true);
  }

  const handleOutsideFocus = () => {
    setFocus(false);
  }
  const handleChangeform = (event) => {
  if (!event || !event.target) return;

  const { name, value } = event.target;

  setAddressData((prev) => ({
    ...prev,
    [name]: value,
  }));

  if (name === "country_code") {
    setValue("city_id", "");
    setValue("district_id", "");
    setCitySearch("");
    setDistrictSearch("");

    const ext = countryExtCodes.find((c) => c.code === value);
    if (ext) {
      setCountryPhoneExt(ext.text);
      setPhonePH(ext.pHolder);
    } else {
      setCountryPhoneExt("+966");
      setPhonePH("5X XXX XXXX");
    }

    setAddressData((prev) => ({
      ...prev,
      country_code: value,
      city_id: "",
      city: "",
      district_id: "",
      district: "",
    }));

    const foundCountry = countryList.find((c) => c.code === value);
    if (!foundCountry) return;

    let cities = foundCountry.cities || [];
    let districts = foundCountry.districts || [];

    if (value === "SA") {
      cities = cities.filter(c => c.value !== "Others");
      districts = districts.filter(d => d.value !== "Others");
    }

    setCityList(cities);
    setDistrictList(districts);
  }
};

  const filteredDistrictList = React.useMemo(() => {
    if (!addressData.city_id || addressData.city_id === "0") return [];

    const selectedCity = cityList.find(
      (city) => city.id == addressData.city_id
    );

    if (!selectedCity) return [];

    let list = districtList.filter(
      (district) => districtBelongsToCity(district, selectedCity)
    );

    if (!districtSearch) return list;

    return list.filter((district) =>
      district.value
        .toLowerCase()
        .includes(districtSearch.toLowerCase())
    );
  }, [
    addressData.city_id,
    districtSearch,
    cityList,
    districtList
  ]);

  const selectedGroup = watch("group");

  React.useEffect(() => {
    if (!selectedGroup) return;

    const currentValues = getValues();

    if (selectedGroup === 2) {
      reset(
        {
          ...currentValues,
          firstname: "",
          middlename: "",
          lastname: "",
          mobile_number: "",
          dob: null,
          gender: "",
          email_lang: "",
          email: "",
        },
        { keepErrors: true, keepDirty: false }
      );
    } else {
      reset(
        {
          ...currentValues,
          full_name_ar: "",
          full_name_en: "",
          id_type: "",
          id_value: "",
          building_no: "",
          postcode: "",
          phone: "",
          dob: null,
          gender: "",
          email_lang: "",
          email: "",
        },
        { keepErrors: true, keepDirty: false }
      );
    }
  }, [selectedGroup]);

  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }
  const closeAlert = () => {
    setOpenAlert(false)
  }

  const clearWholesaleDependentFields = () => {
    // ---- react-hook-form fields ----
    setValue("corporate_name_en", "");
    setValue("corporate_name_ar", "");
    setValue("industry_type", "");
    setValue("full_name_ar", "");
    setValue("full_name_en", "");
    setValue("contact_person_name", "");
    setValue("id_type", "");
    setValue("id_value", "");
    setValue("building_no", "");
    setValue("street", "");
    setValue("city_id", "");
    setValue("district_id", "");
    setValue("postcode", "");
    setValue("phone", "");
    setValue("email", "");
    setValue("dob", null);
    setValue("gender", "");
    setDobValue(null);
    setValue("gender", "", { shouldDirty: false, shouldTouch: false });
    setValue("customer_unique_id", "");

    // ---- address state ----
    setAddressData((prev) => ({
      ...prev,
      street: "",
      city_id: "",
      city: "",
      district_id: "",
      district: "",
      postcode: "",
      phone: "",
      building_no: "",
      id_proof_document: null,
      address_proof_document: null,
      customer_unique_id: "",
    }));

  // ---- uploaded files ----
  setIdProofFile(null);
  setAddressProofFile(null);
};

const wholesaleType = watch("wholesale_type");

React.useEffect(() => {
  if (!wholesaleType) return;

  clearWholesaleDependentFields();
}, [wholesaleType]);




  const buildDocPath = (file, type) => {
  if (!file || !(file instanceof File)) return null;

  const ext = file.name.split(".").pop(); // pdf / jpg / webp
  const uniqueName = `${Date.now()}_${Math.random().toString(36).slice(2)}.${ext}`;

  return `customers/${type}/${uniqueName}`;
};

//const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const MAX_FILE_SIZE = 300 * 1024; // 300 KB

const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
];

const validateDocumentFile = (file) => {
  if (!ALLOWED_FILE_TYPES.includes(file.type)) {
    handleAlertGen("Only PDF, JPG, JPEG, or PNG files are allowed.");
    return false;
  }

  if (file.size > MAX_FILE_SIZE) {
    handleAlertGen("File size must not exceed 300 KB.");
    return false;
  }

  return true;
};
const handleIdProofChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  if (!validateDocumentFile(file)) {
    e.target.value = null;
    return;
  }

  setIdProofFile(file);
  e.target.value = null;
};

const handleAddressProofChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  if (!validateDocumentFile(file)) {
    e.target.value = null;
    return;
  }

  setAddressProofFile(file);
  e.target.value = null;
};

const saveCustomer = async () => {
   if (isSaving) return; 
  setIsSaving(true);


    const fieldVals = getValues();
    const selectedChannel = channel?.toString() || "1";
    //const websiteId = websiteMap[selectedChannel] || websiteMap["1"];    
    const websiteId =
      watch("group") == 2
        ? websiteMap["3"] // always B2B for wholesale
        : websiteMap[selectedChannel] || websiteMap["1"];
    try { clearErrors(); } catch (e) { /* ignore if not available */ }

    const showError = (msg, fieldName) => {
      setIsSaving(false);
      try {
        if (fieldName) setError(fieldName, { type: "manual", message: msg });
      } catch (e) { }
      handleAlertGen(msg);
      if (fieldName) {
        const el = document.querySelector(`[name="${fieldName}"]`);
        if (el && typeof el.focus === "function") {
          el.focus();
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    };
    console.log("Field values:", fieldVals);
    const foundCountry = countryList.find(c => c.code === (fieldVals.country_code || addressData.country_code));
    if (!foundCountry) return showError("Please select a country!", "country_code");
    const selectedCityId = fieldVals.city_id ?? addressData.city_id;
    const selectedDistrictId = fieldVals.district_id ?? addressData.district_id;
    if (selectedCityId == null || selectedCityId === "") return showError("Please select a city!", "city_id");
    if (selectedDistrictId == null || selectedDistrictId === "") return showError("Please select a district!", "district_id");
    if (String(selectedCityId) === "0" && !addressData.city?.trim()) return showError("Please enter a city name!", "city");
    if (String(selectedDistrictId) === "0" && !addressData.district?.trim()) return showError("Please enter a district name!", "district");
    if (fieldVals.group === 1) {
      const city = foundCountry.cities?.find(c => String(c.id) === String(selectedCityId));
      const district = foundCountry.districts?.find(d => String(d.id) === String(selectedDistrictId));
      if (String(selectedCityId) !== "0" && !city) return showError("Please select a valid city!", "city_id");
      if (String(selectedDistrictId) !== "0" && (!district || !districtBelongsToCity(district, city))) {
        return showError("Please select a district belonging to the selected city!", "district_id");
      }
    }
    const selectedCountry = countryExtCodes.find(c => c.code === foundCountry.code);
    if (!selectedCountry) return showError("Please select a valid country.", "country_code");
    const phoneRegex = new RegExp(selectedCountry.regEx);
    const phoneField = fieldVals.group === 2 ? "phone" : "mobile_number";
    if (!phoneRegex.test(fieldVals[phoneField] || '')) {
      return showError(`Invalid phone number format. Expected: ${selectedCountry.pHolder}`, phoneField);
    }
    if (!fieldVals.group) return showError("Please select a customer group!", "group");

    // --- POSTCODE VALIDATION (common for all groups) ---
    const rawPostcode = (fieldVals.postcode || addressData?.postcode || "").toString().trim();

    if (!rawPostcode) {
      return showError("Postcode is required!", "postcode");
    }
    const selectedCountryCode = fieldVals.country_code || addressData?.country_code || foundCountry?.code || "SA";
    if (selectedCountryCode === "QA") {
      const qatarId = ( fieldVals.customer_unique_id || addressData?.customer_unique_id ||  "" ).trim();
      if (!qatarId) {
        return showError("Qatari ID is required for Qatar customers!",
          "customer_unique_id"
        );
      }
      if (!/^\d{11}$/.test(qatarId)) {
        return showError(
          "Qatari ID must be exactly 11 digits!",
          "customer_unique_id"
        );
      }
    }
    // Check if Saudi Arabia
    if ((fieldVals.country_code || addressData?.country_code) === "SA") {
      if (!/^\d{5}$/.test(rawPostcode)) {
        return showError("For Saudi Arabia, postcode must be exactly 5 digits!", "postcode");
      }
    } else {
      // Other countries: numeric + max 9 digits
      if (!/^\d+$/.test(rawPostcode) || rawPostcode.length > 9) {
        return showError("Postcode must be numeric and up to 9 digits only!", "postcode");
      }
    }

    // --- Group specific validation in required order ---
    if (watch("group") == 2) {

      if (!fieldVals.wholesale_type) {
        return showError("Please select Customer Type!", "wholesale_type");
      }
      const isSaudi =
    (fieldVals.country_code || addressData?.country_code) === "SA";

      const checks = [

        { cond: fieldVals.wholesale_type === "Corporate" ? !fieldVals.corporate_name_ar?.trim() : !fieldVals.full_name_ar?.trim(), msg: "Full name (Arabic) is required!", field: fieldVals.wholesale_type === "Corporate" ? "corporate_name_ar" : "full_name_ar" },
        //{ cond: !fieldVals.full_name_ar?.trim(), msg: "Full name (Arabic) is required!", field: "full_name_ar" },
        // { cond: !fieldVals.full_name_en?.trim(), msg: "Full name (English) is required!", field: "full_name_en" },
        { cond: !fieldVals.email?.trim(), msg: "Email is required!", field: "email" },
        { cond: fieldVals.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldVals.email), msg: "Please enter a valid email address!", field: "email" },
        { cond: !fieldVals.building_no?.toString().trim(), msg: "Building No is required!", field: "building_no" }, // building_no included
         { cond: !fieldVals.street?.trim(), msg: "Street is required!", field: "street" },
        { cond: !fieldVals.contact_person_name?.trim(), msg: "Contact Person Name is required!", field: "contact_person_name" },
        {cond: fieldVals.wholesale_type === "Corporate" && !fieldVals.industry_type?.trim(), msg: "Industry Type is required!", field: "industry_type",},
        { cond: !fieldVals.id_type?.toString().trim(), msg: " Customer ID Type is required!", field: "id_type" }, // building_no included
        { cond: !fieldVals.id_value?.toString().trim(), msg: "Customer ID Value  is required!", field: "id_value" }, // building_no included
        { cond: !addressData?.phone?.trim(), msg: "Phone number is required!", field: "phone" },
        { cond: addressData?.phone && !/^\d+$/.test(addressData.phone), msg: "Phone number should contain only digits!", field: "phone" },
        { cond: !fieldVals.country_code && !addressData?.country_code, msg: "Please select a country!", field: "country_code" },
        { cond: !fieldVals.city_id && !addressData?.city_id, msg: "Please select a city!", field: "city_id" },
        //{ cond: fieldVals.city_id && addressData?.city_id == "0" && !addressData?.city, msg: "Please enter a city name!", field: "city" },
        { cond: !fieldVals.district_id && !addressData?.district_id, msg: "Please select a district!", field: "district_id" },
        //{ cond: fieldVals.district_id && addressData?.district_id == "0" && !addressData?.district, msg: "Please enter a district name", field: "district" },
        // { cond: !fieldVals.gender, msg: "Please select gender!", field: "gender" }, // added
        // { cond: !fieldVals.email_lang, msg: "Please choose 'Send Welcome Email' option!", field: "email_lang" }, // added
        
        { 
      cond: String(fieldVals.city_id ?? addressData?.city_id) === "0" && !addressData?.city?.trim(),
      msg: "Please enter a city name!",
      field: "city"
    },

        { 
      cond: String(fieldVals.district_id ?? addressData?.district_id) === "0" && !addressData?.district?.trim(),
      msg: "Please enter a district name!",
      field: "district"
    },
      ];

      const invalid = checks.find(c => c.cond);
      if (invalid) return showError(invalid.msg, invalid.field);
    } else {
      // Non-wholesale (General, Lead page Customers, Retailer)
      const checks = [
        { cond: !fieldVals.firstname?.trim(), msg: "First name is required!", field: "firstname" }, // message changed to clearer wording
        { cond: !fieldVals.lastname?.trim(), msg: "Last name is required!", field: "lastname" },
        { cond: !fieldVals.email?.trim(), msg: "Email is required!", field: "email" },
        { cond: fieldVals.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldVals.email), msg: "Please enter a valid email address!", field: "email" },
        // Mobile number required for non-wholesale per your UI
        { cond: !fieldVals.mobile_number?.toString().trim(), msg: "Mobile number is required!", field: "mobile_number" },

        // { cond: !fieldVals.gender, msg: "Please select gender!", field: "gender" }, // added
        // { cond: !fieldVals.email_lang, msg: "Please choose 'Send Welcome Email' option!", field: "email_lang" }, // added
      ];

      const invalid = checks.find(c => c.cond);
      if (invalid) return showError(invalid.msg, invalid.field);
    }
    const isVat = ["VAT Number"].includes(fieldVals.id_type);
    const isVatOrCr = ["VAT Number", "CR Number"].includes(fieldVals.id_type);

    if (watch("group") == 2 && isVat) {
      const vatNumber = fieldVals.id_value?.toString().trim() || "";
      if (!isValidSaudiVAT(vatNumber)) {
        return showError( "VAT Number must be exactly 15 digits, start with 3, and end with 03!", "id_value");
      }
    }
    // VAT / CR document validation
    if (watch("group") == 2 && isVatOrCr && !idProofFile) {
      return showError("ID Proof document is required for VAT / CR customers!", "id_proof_file");
    }
    // --- If we reached here, basic validation passed. Build payload. ---
    let data = {};
    if (watch("group") == 2) {
      let fullNameEn = "";
      let fullNameAr = "";

      if (fieldVals.wholesale_type === "Corporate") {
        fullNameEn = fieldVals.corporate_name_en || "";
        fullNameAr = fieldVals.corporate_name_ar || "";
      } else {
        fullNameEn = fieldVals.full_name_en || "";
        fullNameAr = fieldVals.full_name_ar || "";
      }

      const enParts = fullNameEn.trim().split(/\s+/);
      const arParts = fullNameAr.trim().split(/\s+/);


      const selectedCityId = fieldVals.city_id ?? addressData?.city_id;
      const selectedDistrictId = fieldVals.district_id ?? addressData?.district_id;
      const fountCity = foundCountry?.cities?.find(c => c.id == selectedCityId);
      const foundDist = foundCountry?.districts?.find(c => c.id == selectedDistrictId);
      data = {
        firstname: enParts[0] || "",
        lastname: enParts.slice(1).join(" ") || "",
        firstnamear: arParts[0] || "",
        lastnamear: arParts.slice(1).join(" ") || "",
        customer_unique_id: selectedCountryCode === "QA" ? ( fieldVals.customer_unique_id || addressData?.customer_unique_id || null ) : null,
        email: fieldVals.email,
        allow_login: 1,
        group_id: fieldVals.group,
        website_id: 0,
        channelId: websiteId,
        customer_type: fieldVals.wholesale_type, // Corporate / Individual
        industry_type: fieldVals.industry_type || null,
        dob: dobValue || null,
        building_no: fieldVals.building_no || null,
        street: fieldVals.street || null,
        contact_person_name: fieldVals.contact_person_name || null,
        id_type: fieldVals.id_type || null,
        id_value: fieldVals.id_value || null,
        gender: fieldVals.gender === "male" ? 1 : 2,
        district_id: selectedDistrictId,
        district: String(selectedDistrictId) === "0" ? addressData?.district?.trim() : foundDist?.value,
        city_id: selectedCityId,
        city: String(selectedCityId) === "0" ? addressData?.city?.trim() : fountCity?.value,
        country: foundCountry.value || fieldVals?.country_name,
        country_id: foundCountry.id || addressData?.country_id,
        postcode: fieldVals.postcode || addressData?.postcode,
      };
      console.log(data)
    } else {
      data = {
        country_id: foundCountry.id,
        country: foundCountry.value,
        city_id: selectedCityId,
        city: String(selectedCityId) === "0" ? addressData.city.trim() : foundCountry.cities?.find(c => c.id == selectedCityId)?.value,
        district_id: selectedDistrictId,
        district: String(selectedDistrictId) === "0" ? addressData.district.trim() : foundCountry.districts?.find(d => d.id == selectedDistrictId)?.value,
        postcode: rawPostcode,
        customer_unique_id: selectedCountryCode === "QA" ? fieldVals.customer_unique_id || addressData.customer_unique_id : null,
        firstname: fieldVals.firstname,
        lastname: fieldVals.lastname,
        email: fieldVals.email,
        allow_login: 1,
        group_id: fieldVals.group,
        website_id: 0,
        channelId: websiteId,
        gender: fieldVals.gender === "male" ? 1 : 2,

      };
    }
    // return
    // phone fields: prefer addressData (used for wholesale) else mobile_number
    const phoneExt = (fieldVals.group === 1 ? selectedCountry.text : addressData?.phone_ext || countryPhoneExt || "").trim();
    const phoneNumber = (fieldVals.group === 2 ? fieldVals.phone : fieldVals.mobile_number)?.toString().trim() || "";
   // const formData = new FormData();
   //const idProofPath = buildDocPath(fieldVals.id_document, "id-proof");
   //const addressProofPath = buildDocPath(fieldVals.address_proof_file, "address-proof");
   const idProofPath = buildDocPath(idProofFile, "id-proof");
const addressProofPath = buildDocPath(addressProofFile, "address-proof");
   const payload = {
     ...data, 
      phone_ext: phoneExt,
      phone: phoneNumber,
      send_welcome_email: fieldVals.email_lang || null, // optional server flag
      id_proof_document: idProofPath ? [idProofPath] : [],
      address_proof_document: addressProofPath ? [addressProofPath] : [],
      action: "register",
    };
const formData = new FormData();
formData.append("data", JSON.stringify(payload));
// Object.entries(payload).forEach(([key, val]) => {
//     // For arrays (documents)
//     if (Array.isArray(val)) {
//         val.forEach(v => formData.append(`${key}[]`, v));
//     } else {
//         formData.append(key, val == null ? "" : val);
//     }
// });

if (idProofFile) formData.append("id_proof_file", idProofFile);
if (addressProofFile) formData.append("address_proof_file", addressProofFile);

// if (idProofFile) {
//   formData.append("id_proof_document", idProofFile);
// }

// if (addressProofFile) {
//   formData.append("address_proof_document", addressProofFile);
// }
    console.log("Payload being sent:", formData);
    console.log("Form Data Entries:",formData);
for (const [k, v] of formData.entries()) {
  console.log("FD:", k, v);
}    
try {
      const signedToken = generateToken(data);
      const res = await axios.post(`${legolasApi.url}/admin/adduser`, formData, {
        headers: {
          Authorization: `Bearer ${signedToken}`,
          //"Content-Type": "application/json",
         // "Content-Type": "multipart/form-data",

        },
      });

      if (res.data && res.data.success) {
        redirect("/users");
      } else {
        // if server returns field-specific errors you can set them inline here
        const msg = (res.data && (res.data.message || res.data.error)) || "Failed to save customer!";
        handleAlertGen(msg);
      }
    } catch (err) {
      console.error("Save customer error:", err);
      if (err.response && err.response.data && err.response.data.message) {
        handleAlertGen(err.response.data.message);
      } else {
        handleAlertGen("Email is already registered for this channel. Please try a different email!");
      }
    } finally {
    setIsSaving(false);
  }
  };

  
  const handleChannelFilter = (event) => {
    const { target: { value } } = event;
    console.log("Selected Channel: ", value);
    setChannel(value);
  };

  //   const saveAndContinue = () => {
  //     const fieldVals = getValues()
  //     const websiteId = channel === '1'
  //       ? process.env.REACT_APP_SHABABUNA_CHANNEL_ID || 1 // Default to 1 for Shababuna
  //       : process.env.REACT_APP_SENSI_CHANNEL_ID || 2;   // Default to 2 for Sensi
  //  if (watch("group") == 2) {
  //     if (!fieldVals.full_name_ar || fieldVals.full_name_en.trim() === "") {
  //       handleAlertGen("Full name (Arabic) is required!");
  //       return;
  //     }
  //     if (!fieldVals.email || fieldVals.email.trim() === "") {
  //       handleAlertGen("Email is required!");
  //       return;
  //     }
  //     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldVals.email)) {
  //       handleAlertGen("Please enter a valid email address!");
  //       return;
  //     }
  //     if (!addressData?.phone || addressData.phone.trim() === "") {
  //       handleAlertGen("Phone number is required!");
  //       return;
  //     }
  //     if (!/^\d+$/.test(addressData.phone)) {
  //       handleAlertGen("Phone number should contain only digits!");
  //       return;
  //     }
  //     if (!fieldVals.city_id) {
  //       handleAlertGen("Please select a city!");
  //       return;
  //     }
  //     if (!fieldVals.district_id) {
  //       handleAlertGen("Please select a district!");
  //       return;
  //     }
  //   } else {
  //     if (!fieldVals.firstname || fieldVals.firstname.trim() === "") {
  //       handleAlertGen("First name is required!");
  //       return;
  //     }
  //     if (!fieldVals.lastname || fieldVals.lastname.trim() === "") {
  //       handleAlertGen("Last name is required!");
  //       return;
  //     }
  //     if (!fieldVals.email || fieldVals.email.trim() === "") {
  //       handleAlertGen("Email is required!");
  //       return;
  //     }
  //     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldVals.email)) {
  //       handleAlertGen("Please enter a valid email address!");
  //       return;
  //     }
  //   }
  //     let data = {}
  //     if (watch("group") == 2) {
  //       data = {
  //         "firstname": fieldVals.full_name_en && fieldVals.full_name_en.split(' ')[0],
  //         "lastname": fieldVals.full_name_en && fieldVals.full_name_en.split(' ')[1],
  //         "firstnamear": fieldVals.full_name_ar && fieldVals.full_name_ar.split(' ')[0],
  //         "lastnamear": fieldVals.full_name_ar && fieldVals.full_name_ar.split(' ')[1],
  //         "email": fieldVals.email,
  //         "allow_login": 1,
  //         "group_id": fieldVals.group,
  //         "website_id": 0,
  //         "channelId": websiteId,
  //         "dob": dobValue ? dobValue : undefined,
  //         "building_no": fieldVals.building_no || null,
  //         "id_type": fieldVals.id_type || null,
  //         "id_value": fieldVals.id_value || null,
  //         'gender': fieldVals.gender == 'male' ? 1 : 2,
  //         'district_id': fieldVals.district_id,
  //         'city_id': fieldVals.city_id,
  //         'country_id': fieldVals.country_id ? fieldVals.country_id : addressData.country_id,
  //         'postcode': fieldVals.postcode,
  //         // ...addressData,
  //       }
  //     } else {
  //       data = {
  //         "firstname": fieldVals.firstname,
  //         "lastname": fieldVals.lastname,
  //         "email": fieldVals.email,
  //         "allow_login": 1,
  //         "group_id": fieldVals.group,
  //         "website_id": 0,
  //         "channelId": websiteId,
  //         "id_type": fieldVals.id_type || null,
  //         "id_value": fieldVals.id_value || null,
  //         //"building_no":fieldVals.building_no || null,
  //         // ...addressData,

  //       }
  //     }
  //     console.log('data fortokn', data)

  //    const phoneExt = (addressData?.phone_ext || countryPhoneExt || '').trim();
  // const phoneNumber = (addressData?.phone || '').trim();
  //     const signedToken = generateToken(data)
  //     const payload = {
  //       ...data,  // Include user data
  //      phone_ext: phoneExt,
  //   phone: phoneNumber,
  //       "action": "register"
  //     }
  //     axios.post(`${legolasApi.url}/admin/adduser`, payload, {
  //       headers: {
  //         'Authorization': `Bearer ${signedToken}`,
  //         'Content-Type': 'application/json'
  //       }
  //     }).then((res) => {
  //       console.log('add user res', res.data)
  //     })
  //   }

  const handleDateChange = (newVal) => {
    setDobValue(newVal)
  }


  const locationFields = (<>
            {/* --- Country --- */}
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 2, marginLeft: '285px', marginTop: '15px' }}>
              <Box sx={{ width: "20%", textAlign: "right", pt: 1 }}>
                Country:
              </Box>

              <Box sx={{ flex: 1 }}>
                <Controller
                  name="country_code"
                  control={control}
                  rules={{ required: "Country is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Select
                          error={!!error}
                          {...field}
                          value={addressData.country_code}
                          onChange={(e) => {
                            field.onChange(e);
                            handleChangeform(e);
                             if (e.target.value !== "QA") { setValue("customer_unique_id", "");
                              setAddressData(prev => ({
                                ...prev,
                              customer_unique_id: "",
                            }));
                          }
                          }}
                          fullWidth
                          sx={{ width: "40%" }}
                        >
                          {countryList.map((country) => (
                            <MenuItem key={country.code} value={country.code}>
                              {country.value}
                            </MenuItem>
                          ))}
                        </Select>
                        {error && <FormHelperText error>{error.message}</FormHelperText>}

                        {addressData.country_code === "QA" && (
                          <Controller
                            name="customer_unique_id"
                            control={control}
                            rules={{
                              required: "Please enter Qatari ID",
                              pattern: {
                                value: /^\d{11}$/,
                                message: "Qatari ID must be 11 digits",
                              },
                            }}
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                {...field}
                                label="Qatari ID (11-Digit)*"
                                value={field.value || addressData.customer_unique_id || ""}
                                error={!!error}
                                helperText={error?.message}
                                inputProps={{
                                  maxLength: 11,
                                  inputMode: "numeric",
                                }}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/\D/g, "");

                                  field.onChange(value);

                                  handleChangeform({
                                    target: {
                                      name: "customer_unique_id",
                                      value,
                                    },
                                  });
                                }}
                                sx={{ width: "40%" }}
                              />
                            )}
                          />
                        )}
                      </Box>
                    </>
                  )}
                />
              </Box>
            </Box>
            {/* --- City --- */}
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 2, ml: "285px" }}>
              <Box sx={{ width: "20%", textAlign: "right", pt: 1 }}>City:</Box>
              <Box sx={{ flex: 1 }}>
                <Controller
                  name="city_id"
                  control={control}
                  rules={{ required: "City is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, }}>

                        <Select
                          error={!!error}
                          {...field}
                          value={addressData.city_id == null ? "" : String(addressData.city_id)}
                          onChange={(e) => {
                            field.onChange(e);
                            handleChangeform(e);
                            setCitySearch("");
                            setValue("district_id", "");
                            setDistrictSearch("");
                            setAddressData(prev => ({
                              ...prev,
                              district_id: "",
                              district: ""
                            }));
                          }}
                          fullWidth
                          sx={{ width: "40%" }}
                          MenuProps={{ autoFocus: false, disableAutoFocusItem: true, }}
                        >
                          <MenuItem disableRipple onClick={(e) => e.stopPropagation()}>
                            <TextField
                              autoFocus
                              placeholder="Search city..."
                              size="small"
                              fullWidth
                              value={citySearch}
                              onChange={(e) => setCitySearch(e.target.value)}
                              onKeyDown={(e) => e.stopPropagation()}
                            />
                          </MenuItem>
                          {cityList.filter((city) => city.value.toLowerCase().includes(citySearch.toLowerCase())).map((city) => (
                            <MenuItem key={city.id} value={String(city.id)}>
                              {city.value}
                            </MenuItem>
                          ))}
                        </Select>
                        {error && <FormHelperText error>{error.message}</FormHelperText>}
                        {String(addressData.city_id) === "0" && (
                          <TextField
                            name="city"
                            label="Enter City Name"
                            value={addressData.city}
                            onChange={handleChangeform}
                            sx={{ width: "40%" }}

                          />
                        )}
                      </Box>
                    </>
                  )}
                />
              </Box>
            </Box>

            {/* --- District --- */}
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 2, ml: "285px" }}>
              <Box sx={{ width: "20%", textAlign: "right", pt: 1 }}>District:</Box>
              <Box sx={{ flex: 1 }}>
                <Controller
                  name="district_id"
                  control={control}
                  rules={{ required: "District is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, }}>

                        <Select
                          error={!!error}
                          {...field}
                          value={addressData.district_id == null ? "" : String(addressData.district_id)}
                          onChange={(e) => {
                            field.onChange(e);
                            handleChangeform(e);
                            setDistrictSearch("");
                          }}
                          sx={{ width: "40%" }}
                          MenuProps={{ autoFocus: false, disableAutoFocusItem: true, }}
                        >
                          <MenuItem disableRipple onClick={(e) => e.stopPropagation()}>
                            <TextField
                              autoFocus
                              placeholder="Search district..."
                              size="small"
                              fullWidth
                              value={districtSearch}
                              onChange={(e) => setDistrictSearch(e.target.value)}
                              onKeyDown={(e) => e.stopPropagation()}
                              onClick={(e) => e.stopPropagation()}
                              inputProps={{ autoComplete: "off" }}
                            />
                          </MenuItem>
                          {filteredDistrictList.filter((district) => String(district.id) !== "0").map((district) => (
                            <MenuItem key={district.id} value={String(district.id)}>
                              {district.value}
                            </MenuItem>
                          ))}
                          {addressData.city_id !== "" && addressData.city_id != null && (
                            <MenuItem value="0">Others</MenuItem>
                          )}
                        </Select>
                        {error && <FormHelperText error>{error.message}</FormHelperText>}
                        {String(addressData.district_id) === "0" && (
                           <TextField
                            name="district"
                            label="Enter District Name"
                            value={addressData.district}
                            onChange={handleChangeform}
                            sx={{ width: "40%" }}
                          />
                            )}
                      </Box>
                    </>
                  )}
                />
              </Box>
            </Box>
  </>);

  const generalPhoneCountry = countryExtCodes.find(c => c.code === addressData.country_code);

  const generalLocationFields = (<>
            {/* --- Country --- */}
                <Controller
                  name="country_code"
                  control={control}
                  rules={{ required: "Country is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                        <TextField
                          select
                          label="Country*"
                          helperText={error?.message}
                          error={!!error}
                          {...field}
                          value={addressData.country_code}
                          onChange={(e) => {
                            field.onChange(e);
                            handleChangeform(e);
                             if (e.target.value !== "QA") { setValue("customer_unique_id", "");
                              setAddressData(prev => ({
                                ...prev,
                              customer_unique_id: "",
                            }));
                          }
                          }}
                          fullWidth
                          sx={controllerFields}
                        >
                          {countryList.map((country) => (
                            <MenuItem key={country.code} value={country.code}>
                              {country.value}
                            </MenuItem>
                          ))}
                        </TextField>
                        {addressData.country_code === "QA" && (
                          <Controller
                            name="customer_unique_id"
                            control={control}
                            rules={{
                              required: "Please enter Qatari ID",
                              pattern: {
                                value: /^\d{11}$/,
                                message: "Qatari ID must be 11 digits",
                              },
                            }}
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                {...field}
                                label="Qatari ID (11-Digit)*"
                                value={field.value || addressData.customer_unique_id || ""}
                                error={!!error}
                                helperText={error?.message}
                                inputProps={{
                                  maxLength: 11,
                                  inputMode: "numeric",
                                }}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/\D/g, "");
                                  field.onChange(value);
                                  handleChangeform({
                                    target: {
                                      name: "customer_unique_id",
                                      value,
                                    },
                                  });
                                }}
                                sx={controllerFields}
                              />
                            )}
                          />
                        )}
                    </>
                  )}
                />
            {/* --- City --- */}
                <Controller
                  name="city_id"
                  control={control}
                  rules={{ required: "City is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                        <TextField
                          select
                          label="City*"
                          helperText={error?.message}
                          error={!!error}
                          {...field}
                          value={addressData.city_id == null ? "" : String(addressData.city_id)}
                          onChange={(e) => {
                            field.onChange(e);
                            handleChangeform(e);
                            setCitySearch("");
                            setValue("district_id", "");
                            setDistrictSearch("");
                            setAddressData(prev => ({
                              ...prev,
                              city: "",
                              district_id: "",
                              district: ""
                            }));
                          }}
                          fullWidth
                          sx={controllerFields}
                          SelectProps={{ MenuProps: { autoFocus: false, disableAutoFocusItem: true } }}
                        >
                          <MenuItem disableRipple onClick={(e) => e.stopPropagation()}>
                            <TextField
                              autoFocus
                              placeholder="Search city..."
                              size="small"
                              fullWidth
                              value={citySearch}
                              onChange={(e) => setCitySearch(e.target.value)}
                              onKeyDown={(e) => e.stopPropagation()}
                            />
                          </MenuItem>
                          {cityList.filter((city) => city.value.toLowerCase().includes(citySearch.toLowerCase())).map((city) => (
                            <MenuItem key={city.id} value={String(city.id)}>
                              {city.value}
                            </MenuItem>
                          ))}
                        </TextField>
                        {String(addressData.city_id) === "0" && (
                          <TextField
                            name="city"
                            label="Enter City Name*"
                            value={addressData.city}
                            onChange={handleChangeform}
                            sx={controllerFields}
                          />
                        )}
                    </>
                  )}
                />
            {/* --- District --- */}
                <Controller
                  name="district_id"
                  control={control}
                  rules={{ required: "District is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                        <TextField
                          select
                          label="District*"
                          helperText={error?.message}
                          error={!!error}
                          {...field}
                          value={addressData.district_id == null ? "" : String(addressData.district_id)}
                          onChange={(e) => {
                            field.onChange(e);
                            handleChangeform(e);
                            setDistrictSearch("");
                            setAddressData(prev => ({ ...prev, district: "" }));
                          }}
                          sx={controllerFields}
                          SelectProps={{ MenuProps: { autoFocus: false, disableAutoFocusItem: true } }}
                        >
                          <MenuItem disableRipple onClick={(e) => e.stopPropagation()}>
                            <TextField
                              autoFocus
                              placeholder="Search district..."
                              size="small"
                              fullWidth
                              value={districtSearch}
                              onChange={(e) => setDistrictSearch(e.target.value)}
                              onKeyDown={(e) => e.stopPropagation()}
                              onClick={(e) => e.stopPropagation()}
                              inputProps={{ autoComplete: "off" }}
                            />
                          </MenuItem>
                          {filteredDistrictList.filter((district) => String(district.id) !== "0").map((district) => (
                            <MenuItem key={district.id} value={String(district.id)}>
                              {district.value}
                            </MenuItem>
                          ))}
                          {addressData.city_id !== "" && addressData.city_id != null && (
                            <MenuItem value="0">Others</MenuItem>
                          )}
                        </TextField>
                        {String(addressData.district_id) === "0" && (
                           <TextField
                            name="district"
                            label="Enter District Name*"
                            value={addressData.district}
                            onChange={handleChangeform}
                            sx={controllerFields}
                          />
                            )}
                    </>
                  )}
                />
  </>);
  return (

    <React.Fragment>
      <Box sx={{ margin: "30px 50px", "& .MuiTypography-root": { fontSize: "2.5rem", fontWeight: 400, color: "#000", }, }} >
        <Typography variant="h5">New Customer</Typography>
      </Box>

      {/* Navigation */}
      <Box>
        <BottomNavigation
          showLabels
          value={actionTab}
          onChange={(event, newValue) => setActiontab(newValue)}
          sx={{
            width: '91%', "& .MuiBottomNavigationAction-root": {
              backgroundColor: globalStyles.colors.white,
              border: "2px solid #2b3f7a !important", color: "#2b3f7a", margin: "5px 10px !important", padding: "0 !important", fontSize: "0.9rem !important",
              "&:hover": { transform: "scale(1.1, 1.1)" },
              "& .Mui-selected": { color: "#2b3f7a", transition: "none", fontSize: "0.9rem", },
            },
          }} >
          <BottomNavigationAction label="Back" onClick={redirectToList} />
          <BottomNavigationAction label="Reset" onClick={resetForm} />
          {/* <BottomNavigationAction
            label="Save and Continue Edit"
            onClick={saveAndContinue}
          /> */}
          <BottomNavigationAction
            label={isSaving ? "Saving..." : "Save Customer"}
            sx={{
              backgroundColor: "#2b3f7a !important",
              border: "2px solid #2b3f7a !important",
              color: "#fff !important",
              "& .Mui-selected": {
                color: "#fff !important",
              },
            }}
            disabled={isSaving}
            onClick={saveCustomer}
          />
        </BottomNavigation>
      </Box>

      <form>
        {/* Associate To */}
        <Controller
          name="associated_to"
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              value={channel}
              onChange={handleChannelFilter}
              sx={controllerDropdowns}
            >
              <MenuItem value={"1"}>Shababuna Website</MenuItem>
              <MenuItem value={"2"}>Sensi Website</MenuItem>
              {/* <MenuItem value={"3"}>B2B Website</MenuItem> */}

            </Select>
          )}
        />

        {/* Customer Group */}
        <Controller
          name="group"
          control={control}
          render={({ field }) => (
            <Select {...field} sx={controllerDropdowns}>
              <MenuItem value={1}>General</MenuItem>
              <MenuItem value={4}>Lead page Customers</MenuItem>
              <MenuItem value={3}>Retailer</MenuItem>
              <MenuItem value={2}>Wholesale</MenuItem>
            </Select>
          )}
        />

        {watch("group") === 2 && (
          <>
            <Controller
              name="wholesale_type"
              control={control}
              rules={{ required: "Please select customer type" }}
              render={({ field, fieldState: { error } }) => (
                <FormControl fullWidth sx={controllerFields} error={!!error}>
                  <InputLabel>Customer Type *</InputLabel>
                  <Select {...field} label="Customer Type"
                    onChange={(e) => {
                      field.onChange(e);
                      clearErrors("wholesale_type");
                    }}
                  >
                    <MenuItem value="Corporate">Corporate</MenuItem>
                    <MenuItem value="Individual">Individual</MenuItem>
                  </Select>
                  {error && <FormHelperText>{error.message}</FormHelperText>}
                </FormControl>
              )}
            />

            {watch("wholesale_type") === "Corporate" && (
              <>
                <Controller
                  name="corporate_name_en"
                  control={control}
                  rules={{ required: "Corporate Name (English) is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      label="Corporate Name (English)*"
                      error={!!error}
                      helperText={error?.message}
                      sx={controllerFields}
                    />
                  )}
                />

                <Controller
                  name="corporate_name_ar"
                  control={control}
                  rules={{ required: "Corporate Name (Arabic) is required",
                    pattern: { value: /^[\u0600-\u06FF\s]+$/, message: "Only Arabic characters are allowed",},
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      label="Corporate Name (Arabic)*"
                      error={!!error}
                      helperText={error?.message}
                      sx={controllerFields}
                      //inputProps={{ dir: "rtl" }}

                    />
                  )}
                />

                <Controller
                  name="industry_type"
                  control={control}
                  rules={{ required: "Industry Type is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      label="Industry Type*"
                      error={!!error}
                      helperText={error?.message}
                      sx={controllerFields}
                    />
                  )}
                />
              </>
            )}


          </>
        )}

        {watch("group") === 2 && watch("wholesale_type") === "Individual" && (
          <>
            <Controller
              name="full_name_ar"
              control={control}
              rules={{ required: "Full Name (Arabic) is required" }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Full Name (Arabic)*"
                  error={!!error}
                  helperText={error?.message}
                  sx={controllerFields}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    setValue("lastname", e.target.value || "");
                  }}
                />
              )}
            />

            <Controller
              name="full_name_en"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Full Name (English)"
                  sx={controllerFields}
                  onChange={(e) => {
                    const val = e.target.value || "";
                    field.onChange(val);

                    const [first = "", ...rest] = val.trim().split(" ");
                    setValue("firstname", first);
                    setValue("lastname", rest.join(" "));
                  }}
                />
              )}
            />
          </>
        )}
        {/* Name Fields */}
        {watch("group") === 2 ? (
          <>

            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 2,
                mb: 2,
                ml: "375px",
                mt: "15px",
              }}
            >
              {/* Label */}
              <Box sx={{ width: "20%", textAlign: "right", pt: "10px" }}>
                Customer ID Type:
              </Box>

              {/* Select + Conditional Input */}
              <Box sx={{ flex: 1 }}>
                {/* Select Box */}
                <Controller
                  name="id_type"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Customer ID Type is required" }}
                  render={({ field }) => {
                    const value = field.value || "";
                    return (
                      <Select
                        {...field}
                        displayEmpty
                        value={value}
                        onChange={(e) => field.onChange(e.target.value)}
                        fullWidth
                        sx={{ width: "36%" }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              mt: 1,
                              borderRadius: "8px",
                              zIndex: 1300,
                            },
                          },
                        }}
                      >
                        <MenuItem value="">
                          - Select ID Type -
                        </MenuItem>
                        <MenuItem value="National ID">National ID</MenuItem>
                        <MenuItem value="Iqama">Iqama</MenuItem>
                        <MenuItem value="VAT Number">VAT Number</MenuItem>
                        <MenuItem value="CR Number">CR Number</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    );
                  }}
                />

                {/* Show input only when ID type selected */}
                {watch("id_type") && (
                  <Box sx={{ mt: 1 }}>
                    <Controller
                      name="id_value"
                      control={control}
                      rules={{ required: "ID Value is required" }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Enter ID Value"
                          fullWidth
                          sx={{ width: "36%" }}
                        />
                      )}
                    />
                    {["VAT Number", "CR Number"].includes(watch("id_type")) && (
                      <Box sx={{ mt: 1, width: "36%" }}>
                        <Controller
                          name="id_document"
                          control={control}
                          rules={{required: ["VAT Number", "CR Number"].includes(watch("id_type")) ? "ID Proof is required for VAT / CR customers" : false, }}
                          // rules={{
                          //   required:
                          //     watch("group") === 2
                          //       ? "Document upload is mandatory for corporate customers"
                          //       : false,
                          // }}
                          render={({ field, fieldState: { error } }) => (
                            <TextField
                              label={`Upload ${watch("id_type")} Document ${watch("group") === 2 ? "*" : ""}`}
                              //value={field.value?.name || ""}
                              value={idProofFile?.name || ""}
                              error={!!error}
                              helperText={error?.message}
                              fullWidth
                              InputProps={{
                                readOnly: true,
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton component="label">
                                      <UploadFileIcon />
                                      <input
                                        type="file"
                                        hidden
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        onChange={handleIdProofChange}
                                        //onChange={(e) => { handleIdProofChange(e);field.onChange(e.target.files?.[0] || null); }}
                                        //onChange={(e) => field.onChange(e.target.files?.[0])}
                                      />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          )}
                        />

                      </Box>
                    )}

                  </Box>
                )}
              </Box>
            </Box>



            <Box
              sx={{
                ml: 60,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                width: "32%",
              }}
            >
              {/* Address Proof Number */}
              {/* <Controller
    name="address_proof_no"
    control={control}
    render={({ field }) => (
      <TextField
        {...field}
        label="National Address Proof *"
        placeholder="Enter Address Proof Number"
        fullWidth
      />
    )}
  /> */}

              {/* Address Proof Upload */}
              <Controller
                name="address_proof_file"
                control={control}
                rules={{ required: false,}}
                //rules={{required: watch("group") === 2 ? "Address proof is mandatory for corporate customers" : false,}}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    label={`Upload Address Proof ${watch("group") === 2 ? "" : "(Optional)"}`}
                    //value={field.value?.name || ""}
                    value={addressProofFile?.name || ""}
                    error={!!error}
                    helperText={error?.message}
                    fullWidth
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton component="label">
                            <UploadFileIcon />
                            <input
                              type="file"
                              hidden
                              accept=".pdf,.jpg,.jpeg,.png"
                              onChange={handleAddressProofChange}
                              //onChange={(e) => { handleAddressProofChange(e); field.onChange(e.target.files?.[0] || null);}}
                              //onChange={(e) => field.onChange(e.target.files?.[0])}
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />

            </Box>

            <Controller
              name="building_no"   // <-- use a valid form field name, not "Building No."
              control={control}
              rules={{ required: "Building No is required" }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Building No.*"
                  onChange={(e) => {
                    field.onChange(e);
                    handleChangeform(e);
                  }}
                  error={!!error}
                  helperText={error ? error.message : ""}
                  fullWidth
                  sx={controllerFields}
                />
              )}
            />
            <Controller
              name="street"   // <-- use a valid form field name, not "Building No."
              control={control}
              rules={{ required: "Street is required" }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Street.*"
                  onChange={(e) => {
                    field.onChange(e);
                    handleChangeform(e);
                  }}
                  error={!!error}
                  helperText={error ? error.message : ""}
                  fullWidth
                  sx={controllerFields}
                />
              )}
            />
            {locationFields}
            <Box sx={{ flex: 1 }}>

              <Controller
                name="contact_person_name"
                control={control}
                rules={{ required: "Contact Person Name is required" }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    label="Contact Person Name*"
                    error={!!error}
                    helperText={error ? error.message : ""}
                    fullWidth
                    sx={controllerFields}
                    onChange={(e) => {
                      field.onChange(e);
                      handleChangeform(e);
                    }}
                  />
                )}
              />
            </Box>


            {/* --- Phone Extension --- */}
            <Controller
              name="phone_ext"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Country Phone Ext"
                  value={countryPhoneExt}
                  disabled
                  fullWidth
                  sx={controllerFields}
                />
              )}
            />

            {/* --- Phone Number --- */}
            <Controller
              name="phone"
              control={control}
              rules={{
                required: "Phone number is required",
                pattern: {
                  value: /^[0-9]{8,15}$/,
                  message: "Enter a valid phone number (8–15 digits)",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Phone Number*"
                  value={addressData.phone}
                  placeholder={phonePH}
                  onChange={(e) => {
                    field.onChange(e);
                    handleChangeform(e);
                  }}
                  fullWidth
                  sx={controllerFields}
                />
              )}
            />
          </>
        ) : (
          <>
            {/* Standard Name Fields */}
            <Controller
              name="firstname"
              control={control}
              rules={{ required: "First Name is required" }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="First Name*"
                  error={!!error}
                  helperText={error ? error.message : ""}
                  sx={controllerFields}
                  onChange={(e) => {
                    field.onChange(e);
                    handleChangeform(e);
                  }}
                />
              )}
            />
            {generalLocationFields}
            <Controller
              name="middlename"
              control={control}
              render={({ field }) => (
                <TextField {...field} label="Middle Name/Initial" sx={controllerFields}
                  onChange={(e) => {
                    field.onChange(e);
                    handleChangeform(e);
                  }}
                />
              )}
            />
            <Controller
              name="lastname"
              control={control}
              rules={{ required: "Last Name is required" }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Last Name*"
                  error={!!error}
                  helperText={error ? error.message : ""}
                  sx={controllerFields}
                  onChange={(e) => {
                    field.onChange(e);
                    handleChangeform(e);
                  }}
                />
              )}
            />

          </>
        )}

        {watch("group") === 1 && (
          <TextField
            label="Country Phone Ext"
            value={generalPhoneCountry?.text || ""}
            InputProps={{ readOnly: true }}
            sx={controllerFields}
          />
        )}

        {/* Mobile Number — only when not Wholesale */}
        {watch("group") !== 2 && (
          <Controller
            name="mobile_number"
            control={control}
            rules={{
              required: "Mobile number is required",
              validate: (value) => {
                if (watch("group") !== 1) return /^\d{1,9}$/.test(value) || "Mobile number must be numeric and up to 9 digits only";
                if (!generalPhoneCountry) return "Please select a valid country";
                return new RegExp(generalPhoneCountry.regEx).test(value || "") ||
                  `Invalid phone number format. Expected: ${generalPhoneCountry.pHolder}`;
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Mobile Number*"
                placeholder={watch("group") === 1 ? generalPhoneCountry?.pHolder : undefined}
                error={!!error}
                helperText={error ? error.message : ""}
                inputProps={{
                  maxLength: watch("group") === 1 ? generalPhoneCountry?.length : 9,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  field.onChange(e);
                }}
                sx={controllerFields}
              />
            )}
          />
        )}
        {/* --- Postal Code --- */}
        <Controller
          name="postcode"
          control={control}
          rules={{ required: "Postcode is required" }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Zip / Postal Code"
              value={addressData.postcode}
              onChange={(e) => {
                field.onChange(e);
                handleChangeform(e);
              }}
              inputProps={{
                maxLength: 10,
                pattern: "[0-9]*",
              }}
              fullWidth
              sx={controllerFields}
            />
          )}
        />
        <Controller
          name="email"
          control={control}
          rules={{
            required: "Email is required",
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Improved regex for email validation
              message: "Enter a valid email address",
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              label="Email*"
              error={!!error}
              helperText={error ? error.message : ""}
              sx={controllerFields}
              onChange={(e) => {
                field.onChange(e);
                handleChangeform(e);
              }}
            />
          )}
        />

        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name='dob'
            control={control}
            rules={{ required: true }}
            render={({ field }) => <DesktopDatePicker
              label="Date of Birth"
              inputFormat="MM/DD/YYYY"
              value={dobValue}
              onChange={(newValue) => {
                field.onChange(newValue);
                handleDateChange(newValue);
                handleChangeform({ target: { name: "dob", value: newValue } });
              }}
              // onChange={handleDateChange}
              renderInput={(params) => <TextField {...params} sx={controllerFields} />}
            />}
          />
        </LocalizationProvider> */}

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name="dob"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <DesktopDatePicker
                label="Date of Birth"
                inputFormat="MM/DD/YYYY"
                value={dobValue}
                onChange={(newValue) => {
                  setDobValue(newValue); // keep local state in sync
                  field.onChange(newValue || null);
                  handleChangeform({ target: { name: "dob", value: newValue || null } });
                }}
                renderInput={(params) => <TextField {...params} sx={controllerFields} />}
              />
            )}
          />
        </LocalizationProvider>


        {/* <Controller 
            name='gender'
            control={control} 
            rules={{ required: true}}
            render={({field}) => 
            <>
          <InputLabel id="gender-select-label" sx={{ ml: 61, mb: 0 }}>Gender*</InputLabel>
            
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              {...field}
              label="Gender*"
              sx={controllerDropdowns}
          >
            <MenuItem value={'male'}>Male</MenuItem>
            <MenuItem value={'female'}>Female</MenuItem>
          </Select>
          </>}
          />
          
          <Controller 
            name='email_lang'
            control={control} 
            rules={{ required: true}}
            render={({field}) => 
            <>
          <InputLabel id="created-in-select-label" sx={{ ml: 61, mb: 0 }}>Send Welcome Email*</InputLabel>
            
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              {...field}
              label="Send Welcome Email*"
              sx={controllerDropdowns}
          >
            <MenuItem value={'english'}>English</MenuItem>
            <MenuItem value={'arabic'}>Arabic</MenuItem>
          </Select>
          </>}
          />  */}

        <Grid container spacing={2} sx={{ mt: 2 }} marginLeft={'450px'}>
          {/* Gender */}
          <Grid item xs={4}>
            <Controller
              name="gender"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="gender-select-label">Gender</InputLabel>
                  <Select
                    {...field}
                    value={field.value ?? ""} 
                    labelId="gender-select-label"
                    id="gender-select"
                    input={<OutlinedInput label="Gender" />}
                  >
                    <MenuItem value="">-- Select Gender --</MenuItem>
                    <MenuItem value="male">Male</MenuItem>
                    <MenuItem value="female">Female</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={8}>
          </Grid>
          {/* Send Welcome Email */}
          {/* <Grid item xs={4}>
            <Controller
              name="email_lang"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="email-lang-label">Send Welcome Email</InputLabel>
                  <Select
                    {...field}
                    labelId="email-lang-label"
                    id="email-lang-select"
                    // 👇 key fix
                    input={<OutlinedInput label="Send Welcome Email" />}
                  >
                    <MenuItem value="">-- Select --</MenuItem>
                    <MenuItem value="english">English</MenuItem>
                    <MenuItem value="arabic">Arabic</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid> */}
        </Grid>
        <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert onClose={closeAlert} severity="warning" sx={{ width: '400px', marginTop: '100px' }}>
            {alertText}
          </Alert>
        </Snackbar>

      </form>
    </React.Fragment>
  );

}

export default CreateUser
